const initialState = {
  isOpen: false,
};

const ModalReducers = (state = initialState, action) => {
  /*if (state.length === 0) {
    return initialState;
  }*/

  const { type } = action;

  switch (type) {
    case "exibeModal":
      return { ...state, isOpen: action.payload.isOpen };
    default:
      return state;
  }
};

export default ModalReducers;
